import React from "react";
import { makeStyles } from "@mui/styles";
import { podHomeDetails } from "../../../assets/lib/home";
import GoPodBasic from "../../../assets/Images/GoPodBasic.mp4";
import GoPodPro from "../../../assets/Images/GoPodPro.mp4";
import GoPodPuzzle from "../../../assets/Images/GoPodPuzzle.mp4";




const customStyles = makeStyles({
  root: {
    width: "90%",
    maxWidth: "1216px",
    display: "flex",
    marginRight: "auto",
    marginLeft: "auto",
    display: "flex",
    flexDirection: "column",
 fontFamily: "Montserrat",
 padding:"20px 0px"
  },
  heading: {
    padding: "35px 15px 0px",
    width: "100%",
    color: "black",
    fontSize: "36px",
    fontWeight: "600",
    display: "flex",
    justifyContent: "center",
     fontFamily: "Montserrat",
  },

  podDetails: {
    marginTop: "20px",
    padding: "10px",
    display: "flex",
  },
  podWrapper: {
    padding: "60px",
    width: "33.33%",
    gap: "40px",
    display: "flex",
    flexDirection: "column",
  },
  podLabel: {
    color: "black",
    fontSize: "20px",
    fontWeight: 600,
    lineHeight: "1.2",
    fontFamily: "Montserrat",
    marginLeft:"120px"

  },
    podVideo: {
    width: "100%",
    height: "580px",
    objectFit: "cover",
    borderRadius: "8px",
    backgroundColor: "#eee",
    cursor: "pointer",
  },

  // Media Query for Small Screens (320px - 480px)
  '@media (min-width: 320px) and (max-width: 480px)': {
    heading: {
      fontSize: "24px", // Font size adjustment for small phones
      padding: "10px 0",
      fontFamily: "Montserrat",
    },
    content: {
      fontSize: "16px", // Adjust content font size
      lineHeight: "24px",
      fontFamily: "Montserrat",
    },
    podDetails: {
      flexDirection: "column",
      marginTop: "30px",
      marginLeft: "-20px",
      fontFamily: "Montserrat",
    },
    podWrapper: {
      width: "100%", // Full width for smaller devices
      padding: "5px",
      fontFamily: "Montserrat",
    },
    podLabel: {
      fontSize: "18px", // Adjust label font size for smaller screens
      fontFamily: "Montserrat",
      marginLeft:"140px"
    },
    snackDetailsWrapper: {
      paddingTop: "60px",
      maxWidth: "100%", // Use full width
      fontFamily: "Montserrat",
    },
    sideHeading: {
      fontSize: "28px", // Adjust heading font size
      fontFamily: "Montserrat",
      
    },
    snackDetail: {
      padding: "10px 5px",
      fontSize: "16px", // Slightly larger font for snack details
      fontFamily: "Montserrat",
    },
  },

  // Media Query for Medium Screens (481px - 768px)
  '@media (min-width: 481px) and (max-width: 768px)': {
    heading: {
      fontSize: "30px", // Adjust heading font size for medium screens
      fontFamily: "Montserrat",
    },
    content: {
      fontSize: "17px", // Slightly smaller than default
      fontFamily: "Montserrat",
    },
    podWrapper: {
      width: "50%", // Two-column layout for medium screens
      fontFamily: "Montserrat",
    },
    podLabel: {
      fontSize: "18px", // Maintain reasonable size for pod labels
      fontFamily: "Montserrat",
      marginLeft:"140px"
    },
    snackDetailsWrapper: {
      paddingTop: "100px",
      maxWidth: "80%",
      fontFamily: "Montserrat",
    },
    sideHeading: {
      fontSize: "32px", // Bigger heading for tablets
      fontFamily: "Montserrat",
    },
    snackDetail: {
      padding: "20px 10px",
      fontSize: "17px",
      fontFamily: "Montserrat",
    },
  },

  // Media Query for Large Screens (769px - 1024px)
  '@media (min-width: 769px) and (max-width: 1024px)': {
    heading: {
      fontSize: "34px", // Larger font size for tablets and small desktops
      fontFamily: "Montserrat",
    },
    content: {
      fontSize: "18px", // Default font size for larger devices
      fontFamily: "Montserrat",
    },
    podWrapper: {
      width: "33.33%", // Three-column layout for larger screens
      fontFamily: "Montserrat",
    },
    podLabel: {
      fontSize: "20px", // Larger labels for bigger screens
      fontFamily: "Montserrat",
      marginLeft:"140px"
    },
    snackDetailsWrapper: {
      paddingTop: "100px",
      maxWidth: "700px",
      fontFamily: "Montserrat",
    },
    sideHeading: {
      fontSize: "34px",
      fontFamily: "Montserrat",
    },
    snackDetail: {
      padding: "30px 15px",
      fontSize: "18px",
      fontFamily: "Montserrat",
    },
  },

  // Media Query for Extra Large Screens (>1024px)
  '@media (min-width: 1025px)': {
    heading: {
      fontSize: "36px", // Keep large font size for larger devices
      fontFamily: "Montserrat",
    },
    content: {
      fontSize: "18px", // Maintain default font size for larger screens.
      fontFamily: "Montserrat",
    },
    podWrapper: {
      width: "33.33%",
      padding: "15px", // More padding for extra large screens
      fontFamily: "Montserrat",
    },
    podLabel: {
      fontSize: "20px", // Consistent font size for labels
      fontFamily: "Montserrat",
      marginLeft:"140px"
    },
    snackDetailsWrapper: {
      paddingTop: "120px",
      maxWidth: "700px",
      fontFamily: "Montserrat",
    },
    sideHeading: {
      fontSize: "36px", // Keep consistent heading size
      fontFamily: "Montserrat",
    },
    snackDetail: {
      padding: "30px 15px",
      fontSize: "18px",
      fontFamily: "Montserrat",
    },
  },
});

const Product = () => {
  const classes = customStyles();

  return (
  <div style={{ backgroundColor:"#a2d8f2"}}>
  <div className={classes.root}>    
   <div className={classes.heading}>Products</div>
  <div className={classes.podDetails}>
    {podHomeDetails.map((pod) => {
      const videoSrc =
        pod.id === "GoPodBasic"
          ? GoPodBasic
          : pod.id === "GopodPro"
          ? GoPodPro
          : GoPodPuzzle;

      return (
        <div className={classes.podWrapper} key={pod.id}>
          <div className={classes.podLabel}>{pod.label}</div>
          <video
            width={358}
            src={videoSrc}
            muted
            loop
            playsInline
            preload="metadata"
            onMouseEnter={(e) => e.target.play()}
            onMouseLeave={(e) => {
              e.target.pause();
              e.target.currentTime = 0; // Rewind to start
            }}
            className={classes.podVideo}
          />
        </div>
      );
    })}
  </div>
</div>
</div>

  );
};

export default Product;
